import axios from '../axios';

class Api {
    static getAllTeelt () {
        return axios.get('/teelt/allbynaam');
    }

    static getListTeelt () {
        return axios.get('/teelt/list');
    }

    static getDetailTeelt (id) {
        return axios.get(`/teelt/${id}`);
    }

    static addTeelt (payload) {
        return axios.post('/teelt', payload);
    }

    static updateTeelt (payload) {
        return axios.post(`/teelt/update/${payload.id}`, payload);
    }

    static deleteTeelt (payload) {
        return axios.post(`/teelt/delete/${payload}`);
    }
}

export default Api;



// WEBPACK FOOTER //
// ./src/api/teelt.js